import React from "react";
import { motion } from "framer-motion";

export default function ProgressBar({ current, total }) {
  const pct = Math.min(100, Math.max(0, (current / total) * 100));
  return (
    <div className="w-full" data-testid="quiz-progress">
      <div className="flex items-center justify-between font-sans text-[10px] tracking-[0.3em] uppercase text-ink/50 mb-2">
        <span>Question {String(current).padStart(2, "0")} / {String(total).padStart(2, "0")}</span>
        <span>{Math.round(pct)}%</span>
      </div>
      <div className="relative h-[2px] w-full bg-sage-300/40">
        <motion.div
          className="absolute left-0 top-0 h-full bg-sage-700"
          initial={false}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        />
        <motion.span
          className="absolute -top-[3px] h-2 w-2 rounded-full bg-sage-700 shadow-sm"
          initial={false}
          animate={{ left: `calc(${pct}% - 4px)` }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
    </div>
  );
}
